import { Controller } from "stimulus"
import Rails from "@rails/ujs";

export default class extends Controller {
  linkcopy(){
    var copyText = document.getElementById("link_name");
    copyText.select();
    document.execCommand("copy");
  }
}